module.exports = __webpack_public_path__ + "assets/img/burger-menu-close.c5892a11.svg";